export default __webpack_public_path__ + "media/400ceadd824ad68b248ac4966dab28184c1667cb88d60d3bf7f6b95a562a1e0e.svg";